<template>
<vue-markdown>
### 请点击左侧菜单选择内容
</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-index',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>